import { ICategory } from "../Categories/type";

export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HABIT_USER_CATEGORIES_REQUEST",
  SUCCESS: "ADMIN_FETCH_HABIT_USER_CATEGORIES_SUCCESS",
  FAILURE: "ADMIN_FETCH_HABIT_USER_CATEGORIES_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_HABIT_USER_CATEGORY_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HABIT_USER_CATEGORY_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_HABIT_USER_CATEGORY_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_HABIT_USER_CATEGORY_SUCCESS",
}

export interface IUserCategory {
  id: number;
  custom_category_name: string;
  date: string | null;
  description: string;
  parent_area: number;
  system_category_name: ICategory | null;
  user: number;
  user_email: string;
}

interface NormalizedEntities {
  [key: string]: IUserCategory;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}